/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { FindFaqByLanguageResponseDto } from "./FindFaqByLanguageResponseDto.ts"

export const findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum =
  {
    FR: "FR",
    EN: "EN",
    ZH: "ZH",
    PT: "PT",
    IT: "IT",
    ES: "ES",
    TR: "TR",
    DE: "DE",
    NL: "NL",
    AR: "AR",
    KO: "KO",
    JA: "JA",
    BE: "BE",
    RO: "RO",
    LT: "LT",
  } as const

export type FindFaqByLanguagePathParamsLangEnumKey =
  (typeof findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum)[keyof typeof findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum]

export type FindFaqByLanguagePathParams = {
  /**
   * @description Language code (ISO 639-1)
   * @type string
   */
  lang: FindFaqByLanguagePathParamsLangEnumKey
}

/**
 * @description FAQs retrieved successfully
 */
export type FindFaqByLanguage200 = FindFaqByLanguageResponseDto[]

export type FindFaqByLanguageQueryResponse = FindFaqByLanguage200

export type FindFaqByLanguageQuery = {
  Response: FindFaqByLanguage200
  PathParams: FindFaqByLanguagePathParams
  Errors: any
}
